import { FC } from "react";
import { SignUp } from "../../../../modules/authentication/components/sign-up/sign-up";

export const SignUpRoute: FC = () => {
    return (
        <SignUp />
    )
}